import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';

import styles from './FullWindowModalCloseButton.module.scss';

interface FullWindowModalCloseButtonProps {
    onClick: () => void;
    className?: string;
    /** Accessibility label. Defaults to "Close". */
    ariaLabel?: string;
}

/**
 * Reference X close button for `FullWindowModal`. Matches the legacy
 * `OverFullWindow`'s close icon spec (faTimes solid, 24×24, no hover color
 * change, transparent background) so screens migrated to the V3 component
 * keep the same visual character across the app.
 *
 * Optional — consumers can render their own close affordance, but using
 * this guarantees consistency.
 */
export const FullWindowModalCloseButton: FunctionComponent<FullWindowModalCloseButtonProps> = ({
    onClick,
    className,
    ariaLabel = 'Close'
}) => {
    return (
        <button
            type="button"
            className={clsx(styles.button, className)}
            onClick={onClick}
            aria-label={ariaLabel}
        >
            <FontAwesomeIcon
                icon={faTimes}
                className={styles.icon}
            />
        </button>
    );
};

export default FullWindowModalCloseButton;
